import * as yup from 'yup'

export const forgotPasswordScehma = yup.object({
    email: yup.string().email('Email must be in a valid format').required('Email is required')
})

export type ForgotPasswordData = yup.InferType<typeof forgotPasswordScehma>